// extracted by mini-css-extract-plugin
export default {"container":"pagination_container__0NvU6 lgt-table__pagination","link":"pagination_link__dmf51 lgt-button--link lgt-button--secondary-black"};